import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';

import BCXButton from '@/components/molecules/BCXButton.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import MyProjectsOverviewTable from '@/views/my-projects/components/overview/MyProjectsOverviewTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsOverview',
  setup(__props) {

const { isNarrow } = useMyProjects();

return { __sfc: true,isNarrow, MyProjectsSectionHeader, BCXButton, MyProjectsOverviewTable }
}

})